import { useEffect, useState } from 'react';

const SCROLL_BUFFER_PIXELS = 10;
const TOP_OF_PAGE_THRESHOLD = 110;

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(
    null
  );

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? 'down' : 'up';

      if (
        direction &&
        direction !== scrollDirection &&
        (scrollY - lastScrollY > SCROLL_BUFFER_PIXELS ||
          scrollY - lastScrollY < -SCROLL_BUFFER_PIXELS)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;

      // reset scroll direction if we're at the top of the page
      if (scrollY < TOP_OF_PAGE_THRESHOLD) {
        setScrollDirection(null);
      }
    };
    window.addEventListener('scroll', updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection); // clean up
    };
  }, [scrollDirection]);

  return scrollDirection;
}
